import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import useAuthPageTheme from '../hooks/useAuthPageTheme';
import MobileAuthShell from '../components/auth/MobileAuthShell';
import AuthSplitLayout from '../components/auth/AuthSplitLayout';
import { AUTH_COPYRIGHT, authCopyrightSx } from '../components/auth/loginDarkTheme';
import { LoginFreeTrialPanel } from '../components/auth/LoginFreeTrialDialog';
import { getNativePlatform } from '../utils/mobileView';
import './LoginPage.css';

export default function FreeTrialPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { isCompact, formPanelThemeClass } = useAuthPageTheme();
  const seedEmail = searchParams.get('email') || '';
  const isIosNative = getNativePlatform() === 'ios';

  const goLogin = () => navigate('/login/');

  useEffect(() => {
    if (isIosNative) {
      navigate('/login/', { replace: true });
    }
  }, [isIosNative, navigate]);

  if (isIosNative) {
    return null;
  }

  if (isCompact) {
    return (
      <MobileAuthShell
        footer={
          <Typography variant="caption" sx={authCopyrightSx}>
            {AUTH_COPYRIGHT}
          </Typography>
        }
      >
        <Box sx={{ width: '100%', maxWidth: 420, mx: 'auto' }}>
          <LoginFreeTrialPanel seedEmail={seedEmail} onBackToLogin={goLogin} compact />
        </Box>
      </MobileAuthShell>
    );
  }

  return (
    <AuthSplitLayout
      brandingVariant="free-trial"
      formPanelThemeClass={formPanelThemeClass}
      containerWide
    >
      <LoginFreeTrialPanel seedEmail={seedEmail} onBackToLogin={goLogin} light compact hideHeader />
    </AuthSplitLayout>
  );
}
